import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'react-bootstrap';

class RetencionStatus extends Component {

  get config() {
    const { status } = this.props;

    let variant = 'success';
    let icon = 'check';
    let text = 'Vigente';

    switch (status) {
      case 'cancelling':
          variant = 'warning';
          icon = 'clock';
          text = 'Cancelando';
        break;

      case 'cancelled':
          variant = 'danger';
          icon = 'check';
          text = 'Cancelado';
        break;

      case 'undefined':
      case undefined:
          variant = 'info';
          icon = 'clock';
          text = '...';
        break;

      default:
        break;
    }

    return {
      icon,
      variant,
      text
    }
  }

  render() {
    const { icon, variant, text } = this.config;

    return (
      <Badge pill variant={ variant }>
        <FontAwesomeIcon icon={ icon } />
        { ' ' } { text }
      </Badge>
    )
  }
}

export default RetencionStatus;